<template>
    <fade-up-animation :element="() => $refs.section">
        <div class="blog-listings-section" ref="section">
            <blog-list-section :blogs="blogs" />

            <b-container>
                <pagination-controls
                    v-if="totalPages > 1"
                    :current-page="currentPage"
                    :total-pages="totalPages"
                />
            </b-container>
        </div>
    </fade-up-animation>
</template>

<script>
    import BlogListSection from '../BlogListSection/BlogListSection';
    import PaginationControls from '../../atoms/PaginationControls/PaginationControls';

    export default {
        name: 'blog-listings-section',

        components: { BlogListSection, PaginationControls },

        props: {
            blogs: {
                type: Array,
                default: () => ([]),
            },

            currentPage: {
                type: Number,
                default: null,
            },

            totalPages: {
                type: Number,
                default: null,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .blog-listings-section {
        padding-top: 30px;
    }

    .blog-list-section {
        margin-bottom: 40px;
    }

    .pagination-controls {
        justify-content: center;
        margin-bottom: 40px;
    }
</style>
